import Highcharts from 'highcharts';
import { isUndefined } from 'lodash-es';
import { numberToHumanChart } from '../../utils/formatter';

export default (options = {}) => ({
  ...(options.loading ? { loading: options.loading } : {}),
  chart: {
    type: 'spline',
    ...(options.chartOptions ? options.chartOptions : {}),
  },
  caption: {
    text: null,
    ...(options.caption ? options.caption : {}),
  },
  subtitle: {
    text: null,
    ...(options.subtitle ? options.subtitle : {}),
  },
  title: {
    text: null,
    ...(options.title ? options.title : {}),
  },
  legend: {
    enabled: false,
    ...(options.legendOptions ? options.legendOptions : {}),
  },
  xAxis: {
    type: 'datetime',
    labels: {
      formatter() {
        return Highcharts.dateFormat('%b %e', this.value);
      },
      ...(options.xAxisLabels || {}),
    },
    ...(options.xAxisOptions ? options.xAxisOptions : {}),
  },
  tooltip: {
    padding: 8,
    formatter() {
      let rows;
      const rowsTemplate = point => `
        ${options.tooltipMaxValue ?
    `<tr>
            <td class='text-left p-l-0'>
              <span style='color:#1FCC67;'>\u25CF +${options.changePercentage()}%:</span>
            </td>
            <td class='text-right p-r-0'>
              <strong>
                ${options.tooltipMaxValue(point.y)}
              </strong>
            </td>
          </tr>`
    : ''
  }
        <tr>
          <td class='text-left p-l-0'>
            <span style='color:${point.series.color};'>\u25CF</span>
              ${point.series.name}
          </td>
          <td class='text-right p-r-0'>
            <strong>
              ${options.tooltipValue
    ? options.tooltipValue(point.y)
    : `${Highcharts.numberFormat(point.y, point.y < 1 && point.y !== 0 ? 2 : 0)}`
  }
            </strong>
          </td>
        </tr>
        ${options.tooltipMinValue ?
    `<tr>
            <td class='text-left p-l-0'>
              <span style='color:#F76863;'>\u25CF -${options.changePercentage()}%:</span>
            </td>
            <td class='text-right p-r-0'>
              <strong>
                ${options.tooltipMinValue(point.y)}
              </strong>
            </td>
          </tr>`
    : ''}
          ${options.tooltipAdditionalValue && options.tooltipAdditionalValue(point.x) !== '0' ?
    `<tr>
            <td class='text-left p-l-0'>
              <span style='color:${options.tooltipAdditionalNameColor};'>\u25CF</span>
                ${options.tooltipAdditionalName}
            </td>
              <td class='text-right p-r-0'>
                <strong>
                  ${options.tooltipAdditionalValue(point.x)}
                </strong>
              </td>
            </tr>`
    : ''
  }`;
      if (Array.isArray(this.points)) {
        rows = this.points.map(point => rowsTemplate(point));
      } else if (this && !Array.isArray(this)) {
        rows = [rowsTemplate(this)];
      } else {
        return null;
      }
      return `
        <strong>${Highcharts.dateFormat('%b %e, %Y', new Date(this.x))}</strong>
        <table class="table">${rows.join('')}</table>
      `;
    },
    ...(options.tooltipOptions || {}),
  },
  yAxis: options.yAxis || {
    title: options.yAxisTitle ? options.yAxisTitle : { text: null },
    minRange: 0.1,
    labels: {
      formatter() {
        if (options.labelValue) return options.labelValue(this.value);
        let value;
        if (this.value < 1) {
          value = this.value;
        } else {
          value = numberToHumanChart(this.value, options.abbreviationSettings);
        }
        return `${value}`;
      },
      ...(options.yAxisLabels || {}),
    },
    ...(options.yAxisOptions ? options.yAxisOptions : {}),
  },
  plotOptions: {
    series: {
      marker: {
        enabled: false,
        symbol: 'circle',
        radius: 2,
      },
      ...(options.plotOptionsSeries || {}),
    },
    spline: {
      accessibility: {
        enabled: true,
      },
      animationLimit: Infinity,
    },
    ...(options.plotOptionsSettings ? options.plotOptionsSettings : {}),
  },
  lang: {
    noData:
      isUndefined(options.showNoDataMessage) ? '<h2 class="text-18 text-muted">No data to display</h2>' : (
        options.showNoDataMessage ? '<h2 class="text-18 text-muted">No data to display</h2>' : null
      ),
  },
  responsive: {
    ...options.responsiveOptions,
  },
  navigator: options.navigator || { enabled: false },
  scrollbar: options.scrollbar || { enabled: false },
  rangeSelector: { enabled: false },
  ...options.exportingOptions,
});
